import React from 'react'
import { Box, Container, Fade, Grid, Typography } from '@mui/material'
import ResponsiveButton from '@components/ResponsiveButton'
import { useTranslation } from 'next-i18next'
import Custom from './components/Custom'
import Regular from './components/Regular'

export function PricingSection() {
  const { t } = useTranslation()
  const [type, setType] = React.useState('regular')
  return (
    <Box>
      <Box
        sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText' }}
        pt={15}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            textAlign="center"
            fontWeight={300}
            sx={{ pb: 6 }}
          >
            <Typography
              variant="h2"
              textAlign="center"
              component="span"
            >
              {t('pricing:hero_pricing_ar')}
            </Typography>{' '}
            {t('pricing:hero_simple')}{' '}
            <Typography
              variant="h2"
              textAlign="center"
              component="span"
            >
              {t('pricing:hero_pricing')}
            </Typography>
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            fontWeight={300}
            sx={{ maxWidth: 591, margin: 'auto', pb: 11 }}
          >
            {t('pricing:hero_title')}
          </Typography>
          <Grid
            container
            spacing={2}
            justifyContent="center"
          >
            <Grid item>
              <ResponsiveButton
                sx={{ width: 280, borderRadius: 10 }}
                variant={type === 'regular' ? 'contained' : 'outlined'}
                onClick={() => setType('regular')}
                color="paper"
                aria-label="regular plans"
              >
                {t('pricing:regular_plans')}
              </ResponsiveButton>
            </Grid>
            <Grid item>
              <ResponsiveButton
                sx={{ width: 280, borderRadius: 10 }}
                variant={type === 'custom' ? 'contained' : 'outlined'}
                onClick={() => setType('custom')}
                color="paper"
                aria-label="custom branded app"
              >
                {t('pricing:custom_branded_app')}
              </ResponsiveButton>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          width: '125%',
          left: '-12.5%',
          height: '200px',
          overflow: 'hidden',
          borderBottomLeftRadius: '50% 100%',
          borderBottomRightRadius: '50% 100%',
          backgroundColor: 'primary.main',
          position: 'relative',
          zIndex: -2,
        }}
      />
      <Container
        maxWidth="md"
        sx={{ mt: -10, pb: 12 }}
      >
        <Fade
          in={type === 'regular'}
          sx={{ display: type === 'regular' ? 'block' : 'none' }}
        >
          <Box>
            <Regular />
          </Box>
        </Fade>
        <Fade
          in={type === 'custom'}
          sx={{ display: type === 'custom' ? 'block' : 'none' }}
        >
          <Box>
            <Custom />
          </Box>
        </Fade>
      </Container>
    </Box>
  )
}

export default PricingSection
